/* Consumer hook for the video player context. */

import { useContext } from "react";
import { VideoPlayerContext } from "@/contexts/videoPlayerContextValue";

export function useVideoPlayer() {
  const ctx = useContext(VideoPlayerContext);
  if (!ctx) throw new Error("useVideoPlayer must be used within VideoPlayerProvider");
  return ctx;
}
